import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import useUserAction from "../user/useUserAction";
import useUserData from "../user/useUserData";

const useLogin = () => {
	const { t } = useTranslation(PAGE_LOGIN)
	const { userLogin } = useUserAction()
	const {loading} = useUserData()
	const onSubmit = (values) => {
		userLogin(values)
	}
	
	const validationSchema = yup.object({
		username: yup
		.string()
		.required(t('Required')),
		password: yup
		.string()
		.required(t('Required'))
	})
	
	const formik = useFormik({
		initialValues: {
			username: '',
			password: '',
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	
	return {
		formik,
		loading
	}
}

export default useLogin